import UAParserContext from '@/context/ua-parser'
import { useCallback, useContext, useSyncExternalStore } from 'react'

function useMediaQuery(query: string, defaultSSRValue = false) {
    const subscribe = useCallback(
        (callback: EventListener) => {
            const matchMedia = window.matchMedia(query)

            matchMedia.addEventListener('change', callback)
            return () => {
                matchMedia.removeEventListener('change', callback)
            }
        },
        [query]
    )

    const getSnapshot = () => {
        return window.matchMedia(query).matches
    }

    const getServerSnapshot = () => {
        return defaultSSRValue
    }

    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

export function useIsMobile() {
    const { deviceType } = useContext(UAParserContext)
    return useMediaQuery('(max-width: 768px)', deviceType === 'mobile')
}

export default useMediaQuery
